if (!window.dAgency) window.dAgency = {};

$(function () {
  const $siteHeader = $('.site-header');
  const $header = $siteHeader.find('.header__container');
  if ($siteHeader <= 0 || $header.length <= 0)
    return false;

  window.dAgency.headerHeight = window.dAgency.announcementBarHeight ? $header.innerHeight() + window.dAgency.announcementBarHeight : $header.innerHeight();
  $('html').css('scroll-padding-top', window.dAgency.headerHeight + 'px');
  $('#PageContainer').css('min-height', 'calc(100vh - ' + window.dAgency.headerHeight + 'px)');

  $(window).on('resize', function () {
    window.dAgency.headerHeight = window.dAgency.announcementBarHeight ? $header.innerHeight() + window.dAgency.announcementBarHeight : $header.innerHeight();
    $('#PageContainer').css('min-height', 'calc(100vh - ' + window.dAgency.headerHeight + 'px)');
  });

  /* ======================== Header ======================== */
  window.dAgency.changeOpacity = (operation, $element) => {
    if ((operation != 'force-opacity' && operation != 'remove-force' && operation != 'toggle') || $element.length <= 0) return;

    if (operation == 'force-opacity') {
      $element.removeClass('apply-transparency');
      $element.addClass('force-opacity');
    }
    else if (operation == 'remove-force') {
      $element.removeClass('force-opacity');
    }
    else if (operation == 'toggle') {
      if (!$element.hasClass('force-opacity')) {
        if ($(window).scrollTop() === 0) {
          $element.addClass('apply-transparency');
        } else {
          $element.removeClass('apply-transparency');
        }
      }
    }
  }

  const $announcementBar = $siteHeader.find('.announcement-bar');
  if ($header.hasClass('header__transparent')) {
    window.dAgency.changeOpacity('toggle', $header);
    window.dAgency.changeOpacity('toggle', $announcementBar);

    $(window).on('scroll', function () {
      window.dAgency.changeOpacity('toggle', $header);
      window.dAgency.changeOpacity('toggle', $announcementBar);
    });
  }

  /* ======================== Mobile Menu ======================== */
  const $mobileMenu = $siteHeader.find('.header__mobile-menu');
  if ($mobileMenu.length > 0) {
    const $firstLevel = $mobileMenu.find('.header__mobile-menu__first-level__title');
    $firstLevel.each(function () {
      const submenu = $(this).data('submenu');
      const $connectedSecondLevel = $mobileMenu.find('.header__mobile-menu__second-level[data-submenu="' + submenu + '"]');
      $(this).on('click', function (e) {
        e.preventDefault();

        if ($connectedSecondLevel.find('.header__mobile-menu__second-level__title').length <= 0) {
          if(e.target.getAttribute('href') || e.target.getAttribute('data-href')) {
            location.href = e.target.getAttribute('href') != null ? e.target.getAttribute('href') : e.target.getAttribute('data-href');
            return;
          }
        }

        $connectedSecondLevel.addClass('open');
        $mobileMenu.addClass('level-open');
      });
    });

    const $secondLevel = $mobileMenu.find('.header__mobile-menu__second-level');
    $secondLevel.each(function () {
      const $level = $(this);
      const $close = $(this).find('.header__mobile-menu__second-level__close');
      $close.on('click', function () {
        $level.removeClass('open');
        $mobileMenu.removeClass('level-open');
      });

      const $titles = $(this).find('.header__mobile-menu__second-level__title');
      $titles.each(function () {
        const accordionIndex = $(this).data('accordion-index');
        const $otherThirdLevels = $level.find('.header__mobile-menu__third-level:not([data-accordion-index="' + accordionIndex + '"])');
        const $connectedThirdLevel = $level.find('.header__mobile-menu__third-level[data-accordion-index="' + accordionIndex + '"]');

        $(this).on('click', function (e) {
          e.preventDefault();         

          if ($connectedThirdLevel.children().length <= 0) {
            if(e.target.getAttribute('href') || e.target.getAttribute('data-href')) {
              location.href = e.target.getAttribute('href') != null ? e.target.getAttribute('href') : e.target.getAttribute('data-href');
              return;
            }
          }

          if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $connectedThirdLevel.slideUp();
            if ($level.find('.header__mobile-menu__second-level__title.open').length <= 0) {
              $level.removeClass('level-open');
            }
          } else {
            $level.addClass('level-open');
            $titles.removeClass('open');
            $otherThirdLevels.slideUp();
            $(this).addClass('open');
            $connectedThirdLevel.slideDown();
          }
        });
      });
    });

    var isMenuOpen = false;
    $siteHeader.find('.header__burger-icon').on('click', function () {
      isMenuOpen = !isMenuOpen;
      $mobileMenu.toggleClass('open');
      $siteHeader.find('.icon-burger').each(function () {
        $(this).toggleClass('open');
      });
      if (isMenuOpen) {
        $('html').css('overflow-y', 'hidden');
        window.dAgency.changeOpacity('force-opacity', $header);
        window.dAgency.changeOpacity('force-opacity', $announcementBar);
      } else {
        $('html').css('overflow-y', '');
        window.dAgency.changeOpacity('remove-force', $header);
        window.dAgency.changeOpacity('remove-force', $announcementBar);
        window.dAgency.changeOpacity('toggle', $header);
        window.dAgency.changeOpacity('toggle', $announcementBar);
      }
    });
  }

  /* ======================== Desktop Menu ======================== */
  const $desktopMenu = $header.find('.header__desktop-menu');
  if ($desktopMenu.length > 0) {
    const $firstLevelLinksContainer = $desktopMenu.find('.header__desktop-menu__inline-elements');
    const $firstLevelLinks = $desktopMenu.find('.header__desktop-menu__inline-elements__link > .underline-hover');
    $firstLevelLinks.each(function () {
      $(this).on('click', function () {
        const $secondLevelOpener = $(this).closest('.header__desktop-menu__inline-elements__link');
        if ($(window).outerWidth() <= 1024 || $secondLevelOpener.length <= 0) return;

        if ($secondLevelOpener.hasClass('open')) {
          $secondLevelOpener.removeClass('open');
          $secondLevelOpener.find('details[open]').removeAttr('open');
          $secondLevelOpener.closest('.header__desktop-menu__inline-elements').removeClass('level-open');
          $secondLevelOpener.find('.level-open').removeClass('level-open');
        } else {
          $secondLevelOpener.closest('.header__desktop-menu__inline-elements').removeClass('level-open');
          $secondLevelOpener.closest('.header__desktop-menu__inline-elements').find('.header__desktop-menu__inline-elements__link.open').each(function () {
            $(this).removeClass('open');
            $(this).find('details[open]').removeAttr('open');
            $(this).find('.level-open').removeClass('level-open');
          });
          $secondLevelOpener.addClass('open');
        }

        if ($firstLevelLinksContainer.find('.header__desktop-menu__inline-elements__link.open').length > 0) {
          $firstLevelLinksContainer.addClass('level-open');
        } else {
          $firstLevelLinksContainer.removeClass('level-open');
        }
      });
    });

    $desktopMenu.find('.header__desktop-menu__second-level').each(function () {
      const $secondLevelDrawer = $(this);
      $(this).css('height', 'calc(100vh - ' + window.dAgency.announcementBarHeight + 'px)');
      $(this).css('padding-left', $('.header__box').css('margin-left'));
      $(this).css('padding-top', $('.header__box').innerHeight() + 'px');

      const $secondLevelCloser = $(this).find('.header__desktop-menu__second-level__close');
      if ($secondLevelCloser.length > 0) {
        $secondLevelCloser.css('top', ($('.header__box').innerHeight() / 2) + 'px');
        $secondLevelCloser.on('click', function () {
          $secondLevelDrawer.closest('.header__desktop-menu__inline-elements__link').removeClass('open');
          $secondLevelDrawer.closest('.header__desktop-menu__inline-elements').removeClass('level-open');
          $secondLevelDrawer.find('details[open]').removeAttr('open');
          $secondLevelDrawer.removeClass('level-open');
        });
      }

      $secondLevelDrawer.find('details').each(function () {
        $(this).on('accordionOpenedEvent', function () {
          $secondLevelDrawer.addClass('level-open');
        })
          .on('accordionClosedEvent', function () {
            if ($secondLevelDrawer.find('details[open]').length <= 0) {
              $secondLevelDrawer.removeClass('level-open');
            }
          });
      });
    });

    $(window).on('resize orientationchange', function () {
      $desktopMenu.find('.header__desktop-menu__second-level').each(function () {
        $(this).css('height', 'calc(100vh - ' + window.dAgency.announcementBarHeight + 'px)');
        $(this).css('padding-left', $('.header__box').css('margin-left'));
        $(this).css('padding-top', $('.header__box').innerHeight());
        $(this).find('.header__desktop-menu__second-level__close').css('top', ($('.header__box').innerHeight() / 2) + 'px');
      });
    });

    ['announcementOpeningEvent', 'announcementClosingEvent'].forEach(evt => {
      document.addEventListener(evt, function () {
        $desktopMenu.find('.header__desktop-menu__second-level').each(function () {
          $(this).css('height', 'calc(100vh - ' + window.dAgency.announcementBarHeight + 'px)');
        });
      });
    });
  }

  /* ======================== Cart Drawer ======================== */
  const $cartDrawer = $('#CartDrawer');
  if ($cartDrawer.length > 0) {
    const marginRight = (document.body.clientWidth - 1440) / 2;
    if (marginRight > 0) {
      $cartDrawer.find('.drawer__menu').css('margin-right', marginRight + 'px');
    }

    $(window).on('resize orientationchange', function () {
      $cartDrawer.css('padding-top', window.dAgency.announcementBarHeight);
      const marginRight = (document.body.clientWidth - 1440) / 2;
      if (marginRight > 0) {
        $cartDrawer.find('.drawer__menu').css('margin-right', marginRight + 'px');
      }
    });

    $(document).on('announcementOpeningEvent announcementClosingEvent', function () {
      $cartDrawer.css('padding-top', window.dAgency.announcementBarHeight);
    });

    $cartDrawer.find('.header__burger-icon').on('click', function () {
      $cartDrawer.find('.js-drawer-close').trigger('click');
      $header.find('.header__burger-icon').trigger('click');
    });
  }

  /* ======================== Search Popup ======================== */
  const $searchPopup = $header.find('.header__search-popup');
  const $searchPopupOpener = $header.find('.search-popup-opener');
  const $cartDrawerSearchPopupOpener = $cartDrawer.find('.drawer__menu__element.drawer__menu__element--search .desktop');
  const $searchTemplateFormInput = $('#searchTemplateFormInput');
      
  function searchPopup() {
    if($searchTemplateFormInput.length > 0 ) {
      $searchTemplateFormInput.trigger('focus');
    } else {
      if ($searchPopup.hasClass('open')) {
        window.dAgency.changeOpacity('remove-force', $header);
        window.dAgency.changeOpacity('remove-force', $announcementBar);
        window.dAgency.changeOpacity('toggle', $header);
        window.dAgency.changeOpacity('toggle', $announcementBar);
        $searchPopup.find('input[type="text"]').trigger('blur');
      } else {
        window.dAgency.changeOpacity('force-opacity', $header);
        window.dAgency.changeOpacity('force-opacity', $announcementBar);
        $searchPopup.find('input[type="text"]').trigger('focus');
      }
      $searchPopup.toggleClass('open');
    }
  }

  if ($searchPopup.length > 0 && $searchPopupOpener.length > 0) {
    $searchPopupOpener.on('click', function () {
      searchPopup();
    });

    $searchPopup.find('.header__search-popup__close').on('click', function () {
      $searchPopup.removeClass('open');
    });
  }

  if($searchPopup.length > 0 && $cartDrawerSearchPopupOpener.length > 0) {
    $cartDrawerSearchPopupOpener.on('click', function () {
      $cartDrawer.find('.js-drawer-close').trigger('click');
      searchPopup();
    });
  }
});
